import PropTypes from "prop-types";
import React, { useState } from "react";

import {
  Row,
  Col,
  Container,
  Form,
  Input,
  FormFeedback,
  Label,
  Alert,
} from "reactstrap";

import { ToastContainer, toast } from 'react-toastify';

//redux
import { useSelector, useDispatch } from "react-redux";

import { Link } from "react-router-dom";
import withRouter from "../../components/Common/withRouter";

// Formik validation
import * as Yup from "yup";
import { useFormik } from "formik";

import { useForm } from 'react-hook-form';

// actions
import { loginUser, socialLogin } from "../../store/actions";

// import images
import logo from "../../assets/images/zayon.png";

//Import config
import CarouselPage from "./CarouselPage";
import { createSelector } from "reselect";

// Import Auth Axios
import { AuthService } from "../../services/auth";
import httpClient from "../../services/httpClient";
import axios from "axios";
import config from "../../config";
const authService = new AuthService(httpClient);

const Login = (props) => {
  const [passwordShow, setPasswordShow] = useState(false);
  const [loading, setLoading] = useState(false);

  const dispatch = useDispatch();

  const errorData = createSelector(
    (state) => state.Login,
    (state) => ({
      error: state.error,
    })
  );
  // Inside your component
  // const { error } = useSelector(errorData);

  const signIn = (type) => {
    dispatch(socialLogin(type, props.router.navigate));
  };

  //for facebook and google authentication
  const socialResponse = (type) => {
    signIn(type);
  };

  document.title = "Login | Zayon";

  const { register, handleSubmit, formState: { errors } } = useForm();

  function onSubmit(data) {
    const res = axios.post(`${config.apiUrl}/api/token/`, {
      "email": data.email,
      "password": data.password
    }).then((e) => {
      setLoading(true)
      toast.success("Conectando ao Painel", {
        autoClose: 1500
      })
      localStorage.setItem('authUser', e.data.access)
      localStorage.setItem('authEmail', data.email)
      setTimeout(() => {
        setLoading(false)
        window.location.href = '/dashboard';
      }, [1500])
    }).catch(err => {
      setLoading(true)
      toast.error("Usuário ou senha inválidos", {
        autoClose: 1500
      })
      setTimeout(() => setLoading(false), [1500])
    })
  }

  return (
    <React.Fragment>
      <div className="auth-page">
        <Container fluid className="p-0">
          <Row className="g-0">
            <Col lg={4} md={5} className="col-xxl-3">
              <div className="auth-full-page-content d-flex px-sm-5 px-4">
                <div className="w-100">
                  <div className="d-flex flex-column h-100">
                    <div className="text-center my-5">
                      <Link to="/dashboard" className="d-block auth-logo">
                        <img src={logo} alt="" width={'100%'} />
                        {/* <span className="logo-txt">Zayon</span> */}
                      </Link>
                    </div>
                    <div className="auth-content my-2">
                      {/* <div className="text-center">
                        <h5 className="mb-0">Welcome Back !</h5>
                        <p className="text-muted mt-2">
                          Sign in to continue to Zayon.
                        </p>
                      </div> */}
                      <Form
                        className="custom-form mt-4 pt-2"
                        onSubmit={handleSubmit(e => onSubmit(e))}
                      >
                        <div className="mb-3">
                          <Label className="form-label">Email</Label>
                          <input
                            className="form-control"
                            placeholder="Digite o e-mail"
                            type="email"
                            name="email"
                            {...register('email', { required: 'Informe seu email' })}
                          />
                          {errors.email && <Alert color="danger" className="p-2 mt-1" >{errors.email.message}</Alert>}
                        </div>

                        <div className="mb-3">
                          <div className="d-flex align-items-start">
                            <div className="flex-grow-1">
                              <Label className="form-label">Senha</Label>
                            </div>
                            <div className="flex-shrink-0">
                              <div className="">
                                <Link
                                  to="/page-recoverpw"
                                  className="text-muted"
                                >
                                  Esqueceu sua senha?
                                </Link>
                              </div>
                            </div>
                          </div>
                          <div className="input-group auth-pass-inputgroup">
                            <input
                              className="form-control"
                              type={passwordShow ? "text" : "password"}
                              placeholder="Digite a senha"
                              name="password"
                              {...register('password', { required: 'Informe sua senha' })}
                            />
                            <button
                              onClick={() => setPasswordShow(!passwordShow)}
                              className="btn btn-light shadow-none ms-0"
                              type="button"
                              id="password-addon"
                            >
                              <i className="mdi mdi-eye-outline"></i>
                            </button>
                          </div>
                          {errors.password && <Alert color="danger" className="p-2 mt-1" >{errors.password.message}</Alert>}
                        </div>

                        <div className="row mb-4">
                          <div className="col">
                            <div className="mt-3 d-grid">
                              <button
                                disabled={!!loading}
                                className="btn btn-primary btn-block"
                                type="submit"
                              >
                                {!loading ? 'Entrar' : <div className="spinner-border spinner-border-sm" role="status"></div>}
                              </button>
                            </div>
                          </div>
                        </div>
                      </Form>

                      <div className="mt-4 text-center">
                        <h5 className="font-size-14 mb-3">Entrar com</h5>

                        <ul className="list-inline">
                          <li className="list-inline-item">
                            <Link
                              to="#"
                              className="social-list-item bg-primary text-white border-primary"
                              onClick={(e) => {
                                e.preventDefault();
                                socialResponse("facebook");
                              }}
                            >
                              <i className="mdi mdi-facebook" />
                            </Link>
                          </li>
                          <li className="list-inline-item">
                            <Link
                              to="#"
                              className="social-list-item bg-danger text-white border-danger"
                              onClick={(e) => {
                                e.preventDefault();
                                socialResponse("google");
                              }}
                            >
                              <i className="mdi mdi-google" />
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div className="mt-2 mt-md-5 text-center">
                      <p className="mb-0">
                        © {new Date().getFullYear()} Developed by Zayon: The first Brazilian decision intelligence company.{" "}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
            <CarouselPage />
          </Row>
        </Container>
      </div>
      <ToastContainer position="bottom-center" />
    </React.Fragment>
  );
};

export default withRouter(Login);

Login.propTypes = {
  history: PropTypes.object,
};
